import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30f72cf9")

_pushScopeId("data-v-30f72cf9")
const _hoisted_1 = { class: "recommend-food-menu-item-area" }
const _hoisted_2 = { class: "recommend-food-menu-item-value-area" }
const _hoisted_3 = { class: "recommend-food-menu-item-status" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CommonRecipeFoodIds = _resolveComponent("CommonRecipeFoodIds")

  return (_openBlock(), _createBlock("div", {
    class: "recommend-food-menu-item",
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickRecipe(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("img", {
        class: "recommend-food-menu-item-image",
        style: _ctx.styleImage,
        src: _ctx.getImage(),
        onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args)))
      }, null, 44, ["src"]),
      _createVNode("div", {
        class: "recommend-food-menu-item-name-view",
        style: _ctx.styleNameView
      }, [
        _createVNode("div", {
          class: "recommend-food-menu-item-name-text",
          style: _ctx.styleNameText
        }, _toDisplayString(_ctx.getName()), 5)
      ], 4)
    ]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.getDish()), 1),
      _createVNode(_component_CommonRecipeFoodIds, {
        class: "recommend-food-menu-item-food-view",
        style: _ctx.styleFoodView,
        foodIds: _ctx.getFoodIds()
      }, null, 8, ["style", "foodIds"])
    ])
  ]))
})